module.exports = __webpack_public_path__ + "static/img/31.c65ffdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/31.png
// module id = t4k1
// module chunks = 1